import { inject, Injector } from '@angular/core';

/**
 * Asynchronously loads and returns the LiveStoreService instance.
 *
 * @param injector - Pass when calling from event handlers or async callbacks.
 *                   Not needed for lifecycle methods (ngOnInit, etc.)
 * @returns Promise<LiveStoreService | null> - Service instance or null if unavailable
 */
export async function getAsyncLiveStoreService(injector?: Injector) {
  try {
    const { LiveStoreService } = await import('@live/services/live-edge-store.service');
    const currentInjector = injector || inject(Injector);
    const liveStore = currentInjector.get(LiveStoreService, null);
    return liveStore;
  } catch (error) {
    // Module not available or injection context error, return null
    return null;
  }
}
